import script from "./Date.vue?vue&type=script&setup=true&lang=ts"
export * from "./Date.vue?vue&type=script&setup=true&lang=ts"

import "./Date.vue?vue&type=style&index=0&id=7c6bdf10&lang=css"

const __exports__ = script;

export default __exports__